<template>
<div class="section-contents-character">
  <div class="font-characters">
    <slot></slot>
    <div class="character-point-list">
    <div class="character-point"
     v-for="point in characterList" :key="point.id"
      :class="{selected: point.id === selectPoint}"
      :style="point.pos"
      @click="getSelectPoint(point.id)"
    >
      <div class="point-btn" :style="setBaseColor"></div>
      <div class="point-contents" :style="setBaseColor">
        <div class="content-text">{{point.contents}}</div>
      </div>
    </div>
    </div>
  </div>
  <div class="font-information">
    <div class="line-card-item" v-for="(value, key) in characterInfo" :key="key">
      <div class="info-image">
        <img :src="`https://static.gabia.com/fonts/project/image/font_information/${key}_icon.svg`" alt="key">
      </div>
      <div class="info-text-content">
        <span class="info-text h5">{{value.text}}</span>
        <span class="info-title">{{value.title}}</span>
      </div>
    </div>
  </div>
</div>

</template>

<script>

export default {
  name: 'FontCharacter',
  data() {
    return {
      selectPoint: -1,
    };
  },
  props: {
    baseColor: {
      type: String,
      default: '#ffffff',
    },
    characterInfo: {
      type: Object,
      default() { return {}; },
    },
    characterList: {
      type: Array,
      default() { return []; },
    },
  },
  computed: {
    setBaseColor() {
      return {
        backgroundColor: `${this.baseColor}`,
      };
    },
  },
  methods: {
    getSelectPoint(id) {
      this.selectPoint = this.selectPoint === id ? -1 : id;
    },
  },
};
</script>

<style  lang="scss" scoped>
.font-characters {
  position: relative;
  margin-bottom: 100px;
  .character-point-list {
    position: absolute;
    top:0;
    width: 100%;
    height: 100%;
    .character-point {
      position: absolute;
      .point-btn {
        cursor: pointer;
        position: absolute;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 2px solid #f2f2f2;
        // background-color: #FF9F64;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &::before, &::after {
          content:'';
          position: absolute;
          width: 2px;
          height: 9px;
          top: 50%;
          left: 50%;
          border-radius: 1px;
          transform: translate(-50%, -50%);
          background-color: #0a0a0a;
        }
        &::after {
          transform: translate(-50%, -50%) rotate(90deg)
        }
      }
      .point-contents {
        position: absolute;
        width: 164px;
        height: 164px;
        padding: 28px;
        border-radius: 50%;
        background-color: #FF9F64;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        transition: transform 250ms ease;
        display: flex;
        align-items: center;
        justify-content: center;
        .content-text {
          text-align: center;
          word-break: keep-all;
        }
      }
      &.selected {
        .point-contents {
          transform: translate(-50%, -50%) scale(1);
        }
      }
    }
  }

}
.font-information {
  display: flex;
  justify-content: space-around;
  .line-card-item {
    position: relative;
    width: 24%;
    max-width: 198px;
    text-align: center;
    border: 1px solid #000;
    &:after {
      content: '';
      position: absolute;
      top: 10px;
      left: 10px;
      width: 100%;
      height: 100%;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
    .info-text-content {
      padding-bottom: 12px;
      &> span {
        display: block;
      }
    }
    .info-image {
      width: 119px;
      height: 119px;
      margin: 0 auto;
      padding: 22px;
    }
  }
}
</style>
